import { render, staticRenderFns } from "./LandListNew.vue?vue&type=template&id=5167c76e&scoped=true&"
import script from "./LandListNew.vue?vue&type=script&lang=js&"
export * from "./LandListNew.vue?vue&type=script&lang=js&"
import style0 from "./LandListNew.vue?vue&type=style&index=0&id=5167c76e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167c76e",
  null
  
)

export default component.exports